import { render } from "./dropZone.vue?vue&type=template&id=f25f2716&scoped=true"
import script from "./dropZone.vue?vue&type=script&lang=js"
export * from "./dropZone.vue?vue&type=script&lang=js"

import "./dropZone.vue?vue&type=style&index=0&id=f25f2716&scoped=true&lang=scss"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25f2716"]])

export default __exports__